<template>
  <div>
    <v-card class="ma-6 pa-6 pb-0" outlined>
      <BoardingClassChartFilter @onFilterChanged="refresh" />
    </v-card>
    <v-card class="ma-6" outlined>
      <BoardingClassChart ref="boarding-class-data-table" :filters="filters" />
    </v-card>
  </div>
</template>

<script>
import BoardingClassChartFilter from './components/BoardingClassChartFilter.vue'
import BoardingClassChart from './components/BoardingClassChart.vue'

export default {
  components: {
    BoardingClassChart,
    BoardingClassChartFilter,
  },
  data() {
    return {
      action: {
        state: 'select',
      },
      filters: null,
      currClass: null,
    }
  },
  methods: {
    refresh(query, currClass) {
      this.action.state = 'filtered'
      this.filters = query
      this.currClass = currClass
      this.$nextTick(() => {
        this.$refs['boarding-class-data-table'].searchboardingClassSessionClass()
      })
    },
  },
}
</script>
